import { Button, SmartLink, YStackProps, SizableText, Stack, YStack, XStack } from '@my/ui'
import { SolitoImage } from 'solito/image'
import { AdCarouselItem as AdCarouselItemProps } from './ad-carousel-props'

export const AdCarouselItem = ({
  title,
  description,
  ctaLabel,
  image,
  href,
  ...props
}: AdCarouselItemProps & YStackProps) => {
  return (
    <YStack gap="$2" {...props}>
      <SmartLink
        Component={YStack}
        href={href}
        gap="$3.5"
        hoverStyle={{
          opacity: 0.85,
        }}
        pressStyle={{
          opacity: 0.8,
        }}
        focusStyle={{
          opacity: 0.8,
        }}
      >
        <Stack overflow="hidden" aspectRatio={1} width="100%" br="$3">
          <SolitoImage
            src={image.url}
            alt={image.alt || title || 'Ad image'}
            contentFit="cover"
            fill
            sizes="(max-width: 768px) 200px, 288px"
          />
        </Stack>
        <YStack gap="$1.5" flex={1}>
          {title && (
            <SizableText
              size="$4.5"
              fow="700"
              $gtSm={{ size: '$7.5', fow: '700' }}
              numberOfLines={2}
            >
              {title}
            </SizableText>
          )}
          {description && (
            <SizableText size="$3" color="$gray12" numberOfLines={2}>
              {description}
            </SizableText>
          )}
        </YStack>
      </SmartLink>
      {ctaLabel && (
        <XStack mt="auto">
          <SmartLink Component={Button} href={href} flex={1} theme="black" size="$4">
            {ctaLabel}
          </SmartLink>
        </XStack>
      )}
    </YStack>
  )
}
